/** 追従カメラの操作バー（docs/06_ui-ux.md 3 章）：距離（近・中・遠）と、カメラで追う選手の切り替え */
import { el } from '../layout';

export type CameraBarPreset = 'near' | 'mid' | 'far';

export interface CameraBarModel {
  visible: boolean;
  preset: CameraBarPreset;
  /** 追っている選手（名前・色・自分かどうか） */
  watched: { name: string; color: string; isPlayer: boolean };
}

export interface CameraBarActions {
  setPreset(p: CameraBarPreset): void;
  prevAthlete(): void;
  nextAthlete(): void;
  watchSelf(): void;
}

const PRESETS: { key: CameraBarPreset; label: string }[] = [
  { key: 'near', label: '近' },
  { key: 'mid', label: '中' },
  { key: 'far', label: '遠' },
];

export function createCameraBar(
  host: HTMLElement,
  actions: CameraBarActions,
): { render(m: CameraBarModel): void } {
  const root = el('div', 'cambar');
  const dist = el('span', 'cambar__group');
  dist.title = 'カメラの距離（Z キーで切り替え）';
  const presetButtons = PRESETS.map(({ key, label }) => {
    const b = el('button', 'cambar__btn', label);
    b.addEventListener('click', () => actions.setPreset(key));
    dist.appendChild(b);
    return { key, b };
  });
  const who = el('span', 'cambar__group');
  const prev = el('button', 'cambar__btn', '◀');
  prev.title = '前の選手（[ キー）';
  prev.addEventListener('click', actions.prevAthlete);
  const name = el('button', 'cambar__name');
  name.title = '自分に戻す（C キー）';
  name.addEventListener('click', actions.watchSelf);
  const next = el('button', 'cambar__btn', '▶');
  next.title = '次の選手（] キー）';
  next.addEventListener('click', actions.nextAthlete);
  who.append(prev, name, next);
  root.append(el('span', 'cambar__label', 'カメラ'), dist, who);
  host.appendChild(root);

  let key = '';
  return {
    render(m) {
      const k = JSON.stringify(m);
      if (k === key) return;
      key = k;
      root.hidden = !m.visible;
      for (const { key: p, b } of presetButtons) b.classList.toggle('cambar__btn--on', p === m.preset);
      name.textContent = m.watched.isPlayer ? 'あなた' : `観戦：${m.watched.name}`;
      name.style.setProperty('--cam-color', m.watched.color);
      name.classList.toggle('cambar__name--other', !m.watched.isPlayer);
    },
  };
}
